<template>
  <div class="card card-1 filters m-b-30 border-radius-5px">
     <div class="card-body">

       <section class="m-b-30">
          <b-row>
            <b-col sm="8">
               <h3>Search Options</h3>
            </b-col>
            <b-col sm="4">
              <b-form-checkbox v-model="checked" name="check-button" switch class="float-right" @input="setIncludeArchivedStatus">
                Include Archived 
              </b-form-checkbox>
            </b-col>
          </b-row>
       </section>

       

      
       

       <section class="m-b-30">
         <b-row>
           <b-col cols="6">
              <label for="">Order Nos.</label>
              <b-form-input @change="setOrderIds" v-model="orderNos" placeholder="Order Nos." size="lg"></b-form-input>
           </b-col>
           <b-col cols="6">
              <label for="">User who uploaded draft:</label>
              <b-form-input @change="setUploaderName"  v-model="uploaderName" placeholder="Source File Uploaded By" size="lg"></b-form-input>
           </b-col>
         </b-row>
        
       </section>

       <section class="m-b-30">
         <b-row>

           <b-col cols="5">
             <label for="">Draft Response Date:</label>
             <b-form-datepicker today-button reset-button  close-button locale="en" id="draft-response-date"
             
              v-model="draftResponseDate" class="mb-2" @input="setUnsetDates('draftResponseDate', 'add')"></b-form-datepicker>
           </b-col>
           
           <b-col cols='2'><div class="orText"><span>OR</span></div></b-col>
           <b-col cols="5">
             <label for="">Draft Sent Date:</label>
             <b-form-datepicker today-button reset-button  close-button locale="en" id="draft-sent-date"
             
              v-model="draftSentDate" class="mb-2" @input="setUnsetDates('draftSentDate', 'add')"></b-form-datepicker>
           </b-col>
           
         </b-row>
       </section>

       

       <ul class="approvalStatusTab">
         <li @click.prevent="setApprovalStatus('Yes')" :class="{active: approvalStatus == 'Yes'}">Approved</li>
         <li @click.prevent="setApprovalStatus('No')" :class="{active: approvalStatus == 'No'}">Not Approved</li>
         <li @click.prevent="setApprovalStatus('Not Touched')" :class="{active: approvalStatus == 'Not Touched'}">Not Touched</li>
       </ul>

       <section v-if="approvalStatus == 'No'">
         <p>Drafts with issues statuses</p>
         <section class="m-b-20">
           <draft-status-selector  v-for="status in draftIssueStatuses" v-bind:key="status.id" :statusId="status.id" :statusName="status.name"/>
         </section>
  
         
         <section v-if="showUserSelector">
           <p>Select the designer who was assigned the task</p>
             <b-row>
               <b-col cols="4">
                  <label for=""></label>
                  <b-form-select v-model="selectedUser" :options="storeUsers" @change="userSelected"></b-form-select>
                  
               </b-col>
             </b-row>
         </section>
       </section>

       
       
     </div>
  </div>
</template>

<script>
import DraftStatusSelector from './draft-status-selector';

  export default {
     data(){
       return {
         selectedUser: null,
         showUserSelector: false,
         approvalStatus: 'Yes',
         orderNos: '',
         uploaderName: '',
         checked: false,
         draftSentDate: '',
         draftResponseDate: ''
       }
     },
     components: {DraftStatusSelector},
     methods: {
       userSelected(id){
          this.$store.dispatch('draft/setSearchUser', id);
       },
       setApprovalStatus(approvalStatus){
         this.approvalStatus = approvalStatus;
         this.$store.dispatch('draft/setUnsetStatusIdInSearch', { statusId: null, shouldSet: false})
         this.$store.dispatch('draft/setApprovalStatus', approvalStatus)
       },
       setOrderIds(){
          this.$store.dispatch('draft/setOrderIds', this.orderNos)
       },
       setIncludeArchivedStatus(){
         console.log(this.checked)
         this.$store.dispatch('draft/setIncludeArchived', this.checked)
       },
       setUploaderName(){

          let uploaderNames = this.uploaderName ? this.uploaderName.trim().split(",").map(user => user.trim().toLowerCase()) : [];
          console.log(uploaderNames)
          if(uploaderNames.length > 0){
             uploaderNames = uploaderNames.filter((value, index) => uploaderNames.indexOf(value) === index);
          }
          
          this.$store.dispatch('draft/setUnsetUploaderNames', uploaderNames)
       },
       setUnsetDates(dateType, action){
          let data = {
             action,
             key: dateType,
             value: this[dateType]
          }
          this.$store.dispatch('draft/setUnsetDates', data)
       }
     },
     watch: {
       searchStatusIdsArray(newValue, oldValue){

          let shouldShowUser = false;

          this.statusThatRequiresUser.forEach(statusId => {
             if(this.searchStatusIdsArray.includes(statusId)){
                shouldShowUser = true;
             }
          })

          if(shouldShowUser){
              this.showUserSelector = true;
              
          }else{
             this.showUserSelector = false;
             
          }
          this.selectedUser = null;
          this.userSelected(null)
       }
     },
     computed: {
        draftIssueStatuses(){
          return this.$store.state.draft.issueStatuses;
        },
        storeUsers(){
           let users = [{text: 'Select Designer', value: null}];
           this.$store.state.draft.users.forEach(user => {
             users.push({text: user.username, value: user.id})
          })
          return users
        },
        searchStatusIdsArray(){
          return this.$store.state.draft.searchData.statusesId
        },
        statusThatRequiresUser(){
           let foundStatus = this.draftIssueStatuses.filter((status) => status.name == 'Processing Request' || status.name == 'Redesign Done' || status.name == 'On Hold').map(status => status.id);
           if(foundStatus.length > 0){
             return foundStatus;
           }else{
             return [];
           }
        },
        
     }
  }
</script>

<style lang="scss" scoped>
  .approvalStatusTab{
     list-style-type: none;
     padding-left: 0;
     li{
       display: inline-block;
       padding: 5px 10px;
       background-color: rgb(235, 235, 235);
       margin-right: 5px;
       border-radius: 5px;
       text-transform: uppercase;
       cursor: pointer;
       font-size: 14px;
       &.active{
         background-color: #0DB3F8;
         color: #fff;
       }
     }
  }
  .orText{
    display: block;
    background-color: rgb(255, 210, 61);
    color: #000;
    text-align: center;
    height: calc(100% - 40px);
    margin-top: 32px;
    border-radius: 5px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>